import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';

import { InlineGridField, InlineGrid } from '@components/form';

import { delictsEventColumns } from '@modules/delicts/_delictsColumns';
import { EventsFormDelictsDelictsForm } from '@modules/events/EventsFormDelictsDelictsForm';
import { withProps, compose } from 'recompose';
import { deleteDelict } from '@modules/delicts/_delictsActions';
import { withNotifications } from '@components/hoc/withNotifications';

const enhance = compose<any, any>(withNotifications({ deleteDelict }));

const View: React.SFC<any> = ({
  disabled,
  locked,
  event,
  reloadEvent,
  eventDefaultPlace,
  deleteDelictNotify,
  context
}) => (
  <Grid fluid={true}>
    <Row>
      <Col className="grid-system-margin" />
    </Row>
    {disabled && !locked && (
      <Row>
        <Col md={12}>
          <h4>Před přidáním je potřeba uložit změny</h4>
        </Col>
      </Row>
    )}
    <Row>
      <Col md={12}>
        <InlineGridField
          component={InlineGrid}
          name="delicts"
          Form={withProps<{}, any>({ event, reloadEvent, eventDefaultPlace, context })(EventsFormDelictsDelictsForm)}
          columns={delictsEventColumns}
          version={'1'}
          showCheckboxes={true}
          deleting={true}
          adding={!disabled}
          editing={!disabled}
          onDelete={checkedItems => {
            checkedItems.forEach(delict => deleteDelictNotify(delict.id));
          }}
        />
      </Col>
    </Row>
    <Row>
      <Col className="grid-system-margin" />
    </Row>
  </Grid>
);

export default enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormDelicts.tsx